import React from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { PageHeader } from '../components/PageHeader';
import { StoriesSection } from '../components/StoriesSection';
import { Heart, Users, BookOpen, Target } from 'lucide-react';
export function StoriesPage() {
  const impactHighlights = [{
    icon: <BookOpen size={32} data-id="element-729" />,
    title: 'Education Transforms Lives',
    description: 'Through our scholarship programs, we help underprivileged students access quality education and unlock their full potential.',
    color: 'bg-sfrr-blue'
  }, {
    icon: <Heart size={32} data-id="element-730" />,
    title: 'Healthcare Saves Lives',
    description: 'Our medical outreach programs bring essential healthcare services to underserved communities across Nigeria.',
    color: 'bg-sfrr-pink'
  }, {
    icon: <Users size={32} data-id="element-731" />,
    title: 'Empowerment Creates Opportunity',
    description: 'We provide skills training and economic opportunities that help women and youth build sustainable livelihoods.',
    color: 'bg-sfrr-green'
  }, {
    icon: <Target size={32} data-id="element-732" />,
    title: 'Community Development Builds Futures',
    description: 'Working with communities to implement sustainable solutions that create lasting positive change.',
    color: 'bg-sfrr-yellow'
  }];
  return <div className="font-sans bg-warm-ivory min-h-screen w-full" data-id="element-733">
      <Header data-id="element-734" />
      <main className="w-full font-sans" data-id="element-735">
        <PageHeader title="Our Impact Stories" subtitle="Discover how we're transforming lives and building stronger communities across Nigeria" badgeText="STORIES OF CHANGE" bgColor="bg-gradient-to-r from-sfrr-green via-sfrr-pink to-sfrr-blue" data-id="element-736" />

        <StoriesSection data-id="element-737" />

        {/* Impact Highlights */}
        <section className="py-16 bg-white" data-id="element-738">
          <div className="container mx-auto px-4" data-id="element-739">
            <div className="text-center mb-12" data-id="element-740">
              <h2 className="text-2xl md:text-3xl font-bold text-charcoal mb-4" data-id="element-741">
                Creating Lasting Change
              </h2>
              <p className="max-w-2xl mx-auto text-gray-600" data-id="element-742">
                Our programs are designed to create sustainable impact by
                addressing root causes and empowering communities to thrive.
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-5xl mx-auto" data-id="element-743">
              {impactHighlights.map((highlight, index) => <div key={index} className="bg-warm-ivory rounded-2xl p-8 shadow-soft hover:shadow-hover transition-all duration-300" data-id="element-744">
                  <div className={`w-14 h-14 rounded-full ${highlight.color} bg-opacity-10 flex items-center justify-center mb-6`} data-id="element-745">
                    <div className={`${highlight.color.replace('bg-', 'text-')}`} data-id="element-746">
                      {highlight.icon}
                    </div>
                  </div>
                  <h3 className="text-xl font-bold text-charcoal mb-3" data-id="element-747">
                    {highlight.title}
                  </h3>
                  <p className="text-gray-600 leading-relaxed" data-id="element-748">
                    {highlight.description}
                  </p>
                </div>)}
            </div>
          </div>
        </section>

        {/* Call to Action */}
        <section className="py-16 bg-warm-ivory" data-id="element-749">
          <div className="container mx-auto px-4" data-id="element-750">
            <div className="max-w-3xl mx-auto text-center bg-white rounded-2xl p-12 shadow-soft" data-id="element-751">
              <h2 className="text-2xl md:text-3xl font-bold text-charcoal mb-4" data-id="element-752">
                Be Part of Our Story
              </h2>
              <p className="text-gray-600 mb-8 leading-relaxed" data-id="element-753">
                Your support helps us continue our mission of uplifting the
                underprivileged and transforming communities across Nigeria.
                Together, we can create lasting change.
              </p>
              <div className="flex flex-col sm:flex-row gap-4 justify-center" data-id="element-754">
                <a href="/donate" className="inline-block" data-id="element-755">
                  <button className="px-8 py-4 bg-sfrr-pink text-white rounded-full font-medium hover:bg-sfrr-pink/90 transition-all duration-300 hover:-translate-y-0.5 shadow-md hover:shadow-lg" data-id="element-756">
                    Support Our Mission
                  </button>
                </a>
                <a href="/get-involved" className="inline-block" data-id="element-757">
                  <button className="px-8 py-4 bg-white text-charcoal border-2 border-charcoal/20 rounded-full font-medium hover:border-charcoal hover:bg-charcoal/5 transition-all duration-300" data-id="element-758">
                    Get Involved
                  </button>
                </a>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer data-id="element-759" />
    </div>;
}